export default __webpack_public_path__ + "static/media/sd-banner-1.74a27a4e.webp";